import React, { useRef, useState, useEffect } from "react";
import { Form, InputNumber, Select, Table, Typography, Input,Space } from 'antd';


export default function RsvpList() {
    const [form] = Form.useForm();
    const [rsvp_list, setRsvpList] = useState([])
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.id === editingKey;

    const GroupOption = (prefix, max) => {
        let option = []
        let thisFix = prefix.toUpperCase() === 'H' ? 'H' : 'W';
        for(let i = 1; i <= max; i++){
            option.push({
                value: `${thisFix.toUpperCase()}${i}`,
                label: `${thisFix.toUpperCase()}${i}`,
            })
        }
        let nextFix = prefix.toUpperCase() === 'H' ? 'W' : 'H';
        for(let i = 1; i <= max; i++){
            option.push({
                value: `${nextFix.toUpperCase()}${i}`,
                label: `${nextFix.toUpperCase()}${i}`,
            })
        }
        let lastFix = 'B';
        for(let i = 1; i <= 10; i++){
            option.push({
                value: `${lastFix.toUpperCase()}${i}`,
                label: `${lastFix.toUpperCase()}${i}`,
            })
        }
        return option
    }

    const edit = (record) => {
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.id);
    };

    const save = async (id) => {
        try{
            // console.log('lets watch ',id);
            const row = await form.validateFields();
            const index = rsvp_list.findIndex((item) => id === item.id);
            
            if(index > -1){
                const item = rsvp_list[index]
                rsvp_list.splice(index, 1, {...item,...row})
                setRsvpList(rsvp_list);
                setEditingKey('');
                let resp = await fetch('/action/update_rsvp', {
                    method: 'PUT',
                    body: JSON.stringify({...item,...row}),
                    headers: { 'Content-Type': 'application/json' },
                })
                let resp_data = await resp.json();
            }
        }catch(err){
            console.log(err)
        }
        
    };

    const cancel = () => {
      setEditingKey('');
    };

    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          editable: true,
          width: 150,
          fixed: 'left',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: 'Mobile',
          dataIndex: 'mobile',
          key: 'mobile',
          width: 150,
          editable: true,
          sorter: (a, b) => a.mobile.localeCompare(b.mobile),
        },
        {
          title: 'Total Coming',
          dataIndex: 'count',
          key: 'count',
          editable: true,
          width: 100,
          sorter: (a, b) => a.count - b.count,
        },
        {
          title: 'Label',
          dataIndex: 'label',
          key: 'label',
          width: 80,
          filters: [
            {
                text: 'Wife',
                value: 'wife',
                children: [
                  {
                    text: 'Friend',
                    value: 'wifeFriend',
                  },
                  {
                    text: 'Relative',
                    value: 'wifeRelative',
                  },
                ],
            },
            {
                text: 'Husband',
                value: 'husband',
                children: [
                  {
                    text: 'Friend',
                    value: 'husbandFriend',
                  },
                  {
                    text: 'Relative',
                    value: 'husbandRelative',
                  },
                ],
            },
          ],
          onFilter: (value, record) => record.label.indexOf(value) === 0,
          sorter: (a, b) => a.label.localeCompare(b.label),
        },
        {
          title: 'Group',
          dataIndex: 'group',
          key: 'group',
          editable: true,
          width: 100,
          sorter: (a, b) => a.group.localeCompare(b.group),
        },
        {
          title: 'Tag',
          dataIndex: 'tag',
          key: 'tag',
          width: 150,
          editable: true,
          sorter: (a, b) => a.tag.localeCompare(b.tag),
        },
        {
          title: 'Registered Date',
          dataIndex: 'createAt',
          key: 'createAt',
          width: 110,
          sorter: (a, b) => a.createAt.localeCompare(b.createAt),
        },
        {
          title: '',
          dataIndex: 'operation',
          fixed: 'right',
          width: 90,
          render: (_, record) => {
            // console.log('rendering now');
            // console.log('_',_)
            // console.log('record',record)
            const editable = isEditing(record);
            return editable ? (
                <Space direction="vertical">
                    <Typography.Link onClick={() => save(record.id)} style={{ marginRight: 10}}>Save</Typography.Link>
                    <Typography.Link onClick={() => cancel()} style={{ marginRight: 10}}>Cancel</Typography.Link>
                </Space>
            ) : (
              <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>Edit</Typography.Link>
            );
          },
        }
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        const numberTypeCol = ['count','count'];
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: numberTypeCol.includes(col.dataIndex) ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    const summary = pageData => {
        let totalCount = 0;
        pageData.forEach(({count}) => { totalCount += Number(count); });
        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}>{totalCount}</Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell index={4}></Table.Summary.Cell>
                <Table.Summary.Cell index={5}></Table.Summary.Cell>
                <Table.Summary.Cell index={6}></Table.Summary.Cell>
                <Table.Summary.Cell index={7}></Table.Summary.Cell>
            </Table.Summary.Row>
        )
    }
    //{editing, dataIndex, title, inputType, record, index,children, ...restProps}
    const EditableCell = ({editing, dataIndex, title, inputType, record, index,children, ...restProps}) => {
        let inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
        const requiredList = ['name','mobile','count']
        const required = requiredList.includes(dataIndex) ? true : false
        const i = rsvp_list.findIndex((item) => record !== undefined ? item.id === record.id : false);
        if(dataIndex === 'group'){
            inputNode = <Select defaultValue={rsvp_list[i][dataIndex]} options={GroupOption(rsvp_list[i].label[0],25)}></Select>
        }
        return (
            <td {...restProps}>
                { editing ? (
                    <Form.Item
                        name={dataIndex} style={{ margin: 0,}}
                        rules={[ (required ? { required: true, message: `Please Input ${title}!` } : {}) ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    (i>-1 ?  rsvp_list[i][dataIndex] : children )
                )}
            </td>
        );
    };

    useEffect(() => {
        // console.log(rsvp_list)
        // console.log(rsvp_list.length === 0)

        if(rsvp_list.length === 0){
            // console.log('check point')
            fetch('/list/rsvp', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
            .then(async response => await response.json())
            .then(data => setRsvpList(data.datas))
            .catch(err => {
                console.log(err)
            })
            console.log('list loaded')
        }
        // console.log('check point 2')
    },[rsvp_list])

    return (
        <div>
            <Form form={form} component={false}>
                <Table 
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={rsvp_list} 
                    columns={mergedColumns} 
                    pagination={{ position: ['bottomCenter'], onChange: cancel, pageSizeOptions:[30,50,100], defaultPageSize: 50 }} 
                    scroll={{ y: window.innerHeight - 135, x: window.innerWidth}} 
                    summary={summary}
                ></Table>
            </Form>
        </div>
    );
}

